<script setup>

import '@css/pages/termsAndConditions.css'

import {useTermsAndConditionsStore} from "@shared/stores/TermsAndConditionsStore"
import useHelpers from "@shared/composables/useHelpers"

const termsAndConditionsStore = useTermsAndConditionsStore()
const {sanitizeHtml} = useHelpers()

</script>

<template>
    <div
        v-if="termsAndConditionsStore.isTermsAndConditionsModalVisible"
        id="divAppTermsAndConditions"
        class="show"
    >
        <div class="divTermsAndConditionsOverlay"></div>
        <div class="divTermsAndConditionsPopup">
            <div class="divTermsAndConditionsHeading">Terms and Conditions</div>
            <div
                id="btnCloseTermsAndConditions"
                @click="() => termsAndConditionsStore.setTermsAndConditionsModalVisibility(false)"
            />

            <div id="divTermsAndConditionsPopupContent">
                <div id="termsAndConditionsPage">
                    <div class="divContentContainer" v-html="sanitizeHtml(termsAndConditionsStore.termsAndConditions)"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    #divAppTermsAndConditions {
        z-index: 2;
    }
</style>
